import { z } from "zod";

const googleSheetsErrorTypeValues = [
  "SHEET_READ_ERROR",
  "PRIMARY_KEY_COLUMN_NOT_FOUND",
  "SHEET_EMPTY",
  "HEADERS_NOT_FOUND",
  "CELL_CHARACTER_LIMIT_EXCEEDED",
] as const;

const googleSheetsErrorTypeSchema = z.enum(googleSheetsErrorTypeValues);
const GoogleSheetsErrorType = googleSheetsErrorTypeSchema.enum;
type GoogleSheetsErrorType = z.infer<typeof googleSheetsErrorTypeSchema>;

interface ErrorDetails {
  sentryDescription: string;
}

export type GoogleSheetsErrors =
  | {
      errorType: typeof GoogleSheetsErrorType.SHEET_READ_ERROR;
      data: {
        spreadsheetId: string;
        sheetName: string;
      };
    }
  | {
      errorType: typeof GoogleSheetsErrorType.PRIMARY_KEY_COLUMN_NOT_FOUND;
      data: {
        primaryKeyColumn: string;
        sheetName: string;
      };
    }
  | {
      errorType: typeof GoogleSheetsErrorType.SHEET_EMPTY;
      data: {
        spreadsheetId: string;
        sheetName: string;
      };
    }
  | {
      errorType: typeof GoogleSheetsErrorType.HEADERS_NOT_FOUND;
      data: {
        spreadsheetId: string;
        sheetName: string;
      };
    }
  | {
      errorType: typeof GoogleSheetsErrorType.CELL_CHARACTER_LIMIT_EXCEEDED;
      data: {
        spreadsheetId: string;
        sheetName: string;
        columnName: string;
        primaryKeyValue: string;
        characterCount: number;
        maxCharacters: number;
      };
    };

export const googleSheetsErrorDetails: Record<GoogleSheetsErrorType, ErrorDetails> = {
  [GoogleSheetsErrorType.SHEET_READ_ERROR]: {
    sentryDescription: "Failed to read from Google Sheet",
  },
  [GoogleSheetsErrorType.PRIMARY_KEY_COLUMN_NOT_FOUND]: {
    sentryDescription: "Primary key column not found in sheet headers",
  },
  [GoogleSheetsErrorType.SHEET_EMPTY]: {
    sentryDescription: "Google Sheet is empty",
  },
  [GoogleSheetsErrorType.HEADERS_NOT_FOUND]: {
    sentryDescription: "Headers not found in Google Sheet",
  },
  [GoogleSheetsErrorType.CELL_CHARACTER_LIMIT_EXCEEDED]: {
    sentryDescription: "Cell value exceeds Google Sheets character limit",
  },
};
